import React from "react";
import {
  StyleSheet,
  View,
  Modal,
  TouchableWithoutFeedback,
} from "react-native";
import Cross from "@assets/svg/CrossIcon";
import Text from "@components/CustomText";
import color from "@constants/color";

const CashCollectionModal = ({
  showModal,
  setShowModal,
  totalCollectedFromCxSummary,
}) => (
  <Modal visible={showModal} animationType="slide" transparent>
    <TouchableWithoutFeedback
      onPress={() => {
        setShowModal(false);
      }}
    >
      <View style={styles.modalOverlay} />
    </TouchableWithoutFeedback>
    <View style={styles.modalContent}>
      <View style={styles.modalCross}>
        <TouchableWithoutFeedback onPress={() => setShowModal(false)}>
          <Cross width={16} height={16} />
        </TouchableWithoutFeedback>
      </View>
      <View style={styles.modalInnerContent}>
        <Text variant="title_20">{totalCollectedFromCxSummary?.title}</Text>
        <View style={styles.summaryContainer}>
          <Text variant="title_16" style={{ marginBottom: 8 }}>
            {totalCollectedFromCxSummary?.subtitle}
          </Text>
          {totalCollectedFromCxSummary?.list.map((item) => (
            <View key={item?.route_name} style={styles.listItem}>
              <Text variant="caption_2" style={styles.routeName}>
                {item.route_name}
              </Text>
              <Text variant="body_text_2">{`₹ ${item.amount}`}</Text>
            </View>
          ))}
        </View>
        <View style={styles.totalContainer}>
          <Text variant="caption_2" style={styles.totalLabel}>
            Total cash collected from customer
          </Text>
          <Text variant="title_20">{`₹ ${totalCollectedFromCxSummary?.totalCollectedFromCx}`}</Text>
        </View>
      </View>
    </View>
  </Modal>
);

export default CashCollectionModal;

const styles = StyleSheet.create({
  modalOverlay: {
    backgroundColor: "rgba(0,0,0, 0.4)",
    flex: 1,
  },
  modalContent: {
    backgroundColor: "#fff",
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    width: "100%",
    position: "absolute",
    bottom: 0,
  },
  modalCross: {
    position: "absolute",
    right: 10,
    top: -35,
    backgroundColor: "#fff",
    borderRadius: 50,
    zIndex: 1,
    padding: 6,
  },
  modalInnerContent: {
    padding: 16,
  },
  summaryContainer: {
    backgroundColor: color.white,
    padding: 12,
    borderColor: color.lighterBlack,
    borderWidth: 1,
    marginVertical: 12,
    borderRadius: 16,
  },
  listItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 4,
    paddingVertical: 4,
    borderRadius: 16,
    alignItems: "center",
  },
  routeName: {
    color: color.black06,
  },
  totalContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 8,
    paddingVertical: 6,
    borderRadius: 16,
    alignItems: "center",
  },
  totalLabel: {
    color: color.black06,
  },
});
